<template>
  <div class="model-second-title">
    {{params.label || rowData[params.key]}}
  </div>
</template>

<script>
export default {
  name: 'v-title',
  props: ['params', 'rowData']
}
</script>

<style lang="less">
@import "../../../styles/index.less";
</style>
